function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "illustrations/realisation-alt"
}, React.createElement("g", {
  id: "board"
}, React.createElement("g", {
  id: "neutral"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 32,
  y: 31,
  width: 87,
  height: 206,
  rx: 2,
  fill: "#DDDDDD"
}), React.createElement("rect", {
  id: "Rectangle_2",
  x: 129.969,
  y: 31.1649,
  width: 86.6462,
  height: 205.96,
  rx: 2,
  fill: "#DDDDDD"
}), React.createElement("rect", {
  id: "Rectangle_3",
  x: 227.446,
  y: 31.1649,
  width: 86.6462,
  height: 205.96,
  rx: 2,
  fill: "#DDDDDD"
}))), React.createElement("g", {
  id: "cards"
}, React.createElement("g", {
  id: "accent"
}, React.createElement("rect", {
  id: "Rectangle_4",
  x: 43.3231,
  y: 42.005,
  width: 64.9846,
  height: 32.52,
  rx: 2,
  fill: "#FFFAFA"
}), React.createElement("rect", {
  id: "Rectangle_5",
  x: 140.8,
  y: 42.005,
  width: 64.9846,
  height: 32.52,
  rx: 2,
  fill: "#FFFAFA"
}), React.createElement("rect", {
  id: "Rectangle_6",
  x: 238.277,
  y: 42.005,
  width: 64.9846,
  height: 32.52,
  rx: 2,
  fill: "#FFFAFA"
}), React.createElement("rect", {
  id: "Rectangle_7",
  x: 43.3231,
  y: 128.725,
  width: 64.9846,
  height: 32.52,
  rx: 2,
  fill: "#FFFAFA"
}), React.createElement("rect", {
  id: "Rectangle_8",
  x: 43.3231,
  y: 85.3649,
  width: 64.9846,
  height: 32.52,
  rx: 2,
  fill: "#FFFAFA"
}), React.createElement("rect", {
  id: "Rectangle_9",
  x: 238.277,
  y: 85.3649,
  width: 64.9846,
  height: 32.52,
  rx: 2,
  fill: "#FFFAFA"
})), React.createElement("g", {
  id: "brand"
}, React.createElement("rect", {
  id: "Rectangle_10",
  x: 140.8,
  y: 42.005,
  width: 10.8308,
  height: 32.52,
  rx: 2,
  fill: "#6534FF"
}), React.createElement("rect", {
  id: "Rectangle_11",
  x: 238.277,
  y: 42.005,
  width: 10.8308,
  height: 32.52,
  rx: 2,
  fill: "#6534FF"
}), React.createElement("rect", {
  id: "Rectangle_12",
  x: 43.3231,
  y: 42.005,
  width: 10.8308,
  height: 32.52,
  rx: 2,
  fill: "#6534FF"
}), React.createElement("rect", {
  id: "Rectangle_13",
  x: 43.3231,
  y: 85.3649,
  width: 10.8308,
  height: 32.52,
  rx: 2,
  fill: "#6534FF"
}), React.createElement("rect", {
  id: "Rectangle_14",
  x: 43.3231,
  y: 128.725,
  width: 10.8308,
  height: 32.52,
  rx: 2,
  fill: "#6534FF"
}), React.createElement("rect", {
  id: "Rectangle_15",
  x: 238.277,
  y: 85.3649,
  width: 10.8308,
  height: 32.52,
  rx: 2,
  fill: "#6534FF"
})), React.createElement("g", {
  id: "neutral_2"
}, React.createElement("ellipse", {
  id: "Ellipse",
  cx: 102.892,
  cy: 69.105,
  rx: 4.06154,
  ry: 4.065,
  fill: "#DDDDDD"
}), React.createElement("ellipse", {
  id: "Ellipse_2",
  cx: 200.369,
  cy: 69.105,
  rx: 4.06154,
  ry: 4.065,
  fill: "#DDDDDD"
}), React.createElement("ellipse", {
  id: "Ellipse_3",
  cx: 297.846,
  cy: 112.465,
  rx: 4.06154,
  ry: 4.065,
  fill: "#DDDDDD"
}), React.createElement("ellipse", {
  id: "Ellipse_4",
  cx: 297.846,
  cy: 69.105,
  rx: 4.06154,
  ry: 4.065,
  fill: "#DDDDDD"
}))), React.createElement("g", {
  id: "icon"
}, React.createElement("g", {
  id: "brand_2"
}, React.createElement("path", {
  id: "Shape",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M280.474 218.066C279.657 219.575 277.444 219.423 276.842 217.816L273.09 207.805C272.815 207.071 272.994 206.244 273.548 205.689L280.636 198.596C281.743 197.488 283.635 198.024 283.997 199.547L285.802 207.154C285.916 207.632 285.849 208.135 285.615 208.568L280.474 218.066ZM248.025 188.976C246.42 188.374 246.267 186.163 247.774 185.346L257.269 180.197C257.702 179.963 258.206 179.896 258.685 180.01L266.286 181.817C267.808 182.179 268.344 184.069 267.238 185.176L260.148 192.272C259.593 192.827 258.765 193.007 258.031 192.731L248.025 188.976ZM245.891 210.013C248.279 203.876 252.268 206.415 252.9 206.868C252.959 206.911 253.011 206.957 253.063 207.009L255.993 209.936L258.893 212.828C258.945 212.881 258.993 212.934 259.037 212.994C259.489 213.628 261.979 217.568 255.865 219.971C253.847 220.515 251.747 220.688 249.667 220.48C248.74 220.394 245.992 221.982 244.486 222.189C244.027 222.252 243.662 221.891 243.722 221.432C243.917 219.922 245.508 217.167 245.416 216.235C245.193 214.149 245.354 212.04 245.891 210.013Z",
  fill: "#6534FF"
})), React.createElement("g", {
  id: "accent_2"
}, React.createElement("path", {
  id: "Shape_2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M252.763 195.848C272.544 176.271 289.023 170.272 295.205 168.596C296.499 168.245 297.574 169.326 297.215 170.618C295.513 176.752 289.448 193.027 269.725 212.561C269.699 212.586 269.678 212.609 269.653 212.634C269.145 213.164 262.769 219.458 254.279 211.055C249.846 207.179 249.183 200.524 252.763 195.848Z",
  fill: "#FFFAFA"
})), React.createElement("g", {
  id: "brand_3"
}, React.createElement("path", {
  id: "Shape_3",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M275.705 190.155C278.012 192.543 277.958 196.347 275.585 198.668C273.211 200.989 269.41 200.954 267.079 198.59C264.748 196.226 264.764 192.421 267.114 190.077C269.515 187.742 273.347 187.777 275.705 190.155Z",
  fill: "#6534FF"
}))));

var SvgRealisationAlt = function SvgRealisationAlt(props) {
  return React.createElement("svg", _extends({
    width: 352,
    height: 271,
    viewBox: "0 0 352 271",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,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";
export { SvgRealisationAlt as ReactComponent };